// THE ONE FIND. The header's search (GlobalSearch) is also the page's find:
// what you type there finds across everything (its dropdown) AND narrows the
// page you are on, for any page that listens (FindField). Navigating clears it.
let term = '';
const listeners = new Set();

export function setFind(next) {
    term = next || '';
    listeners.forEach((fn) => fn(term));
}

export function onFind(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
}

// ⌘K FROM ANY PAGE goes Home and puts you in its search: the page you leave
// asks, and the search on Home takes the ask as it mounts.
let asked = false;
export const askSearch = () => { asked = true; };
export const takeSearchAsk = () => { const a = asked; asked = false; return a; };
